import React, { useState } from 'react';
import './ChatWithUs.css';
import WhatsappIcon from '../../assets/icons/whatsapp.svg';
import NewbellLogo from '../../assets/newbell.png';

const ChatWithUs = () => {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = '66988540410'; // Thailand number
  const message = encodeURIComponent('Hello! I have a question.');
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <div className={`chat-container ${isOpen ? 'open' : ''}`}>
      {!isOpen ? (
        <button className="chat-button" onClick={() => setIsOpen(true)}>
          <img src={WhatsappIcon} alt="WhatsApp" className="chat-icon" />
          Chat with us
        </button>
      ) : (
        <div className="chat-box">
          <p className="chat-greeting">
            Hello!<br />Click on our contact below to chat on WhatsApp
          </p>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="chat-profile"
          >
            <img src={NewbellLogo} alt="Newbell Logo" className="profile-img" />
            <div className="chat-info">
              <p className="chat-title">Support</p>
              <p className="chat-name">Varun Newbell</p>
            </div>
          </a>
          <button className="close-btn" onClick={() => setIsOpen(false)}>
            ✕
          </button>
        </div>
      )}
    </div>
  );
};

export default ChatWithUs;
